import "./App.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Spain" />

        <footer>
          This project has been coded by Susanna Mjetk and is{" "}
          <a
            href="https://silver-kelpie-c76d5e.netlify.app"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
